export default {
  metaTitle: {
    id: 'feedback_form_meta_title',
    defaultMessage: 'Feedback - Merchant - Back Market',
  },
  metaDescription: {
    id: 'feedback_form_meta_description',
    defaultMessage: 'Give us your feedback!',
  },
}
